import { IGetControlePatrimonioByIdUseCase } from "../../../presentation/useCases/read/get_controlede_patrimonio_by_id_use_case";
import { ControlePatrimonioDetalhes } from "../../models/controle_patrimonio_detalhes";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetControledePatrimonioByIdUseCase
 */
export class GetControledePatrimonioByIdUseCase implements IGetControlePatrimonioByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async getControlePatrimonioById(
    idMaquinaEquip: number | undefined,
  ): Promise<ControlePatrimonioDetalhes> {
    if (idMaquinaEquip === undefined) throw new Error("Falha ao obter id da máquina/equipamento!");
    const response = await this.repository.getControlePatrimonioById(idMaquinaEquip);
    if (response === null) throw new Error("Falha ao obter detalhes da máquina/equipamento!");
    return response;
  }
}
